/* Two Worlds — real cart wiring (Shopify).
   Intercepts the shelf's product forms, adds via AJAX, bounces the jar. */

(function () {
  var cartBtn = document.querySelector('.cart-btn');
  var cartCount = document.querySelector('.cart-count');

  function setCount(n) {
    if (!cartCount) return;
    cartCount.textContent = String(n);
    if (cartBtn) cartBtn.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }

  function bounce() {
    if (!cartBtn || !cartCount) return;
    cartBtn.classList.remove('is-adding');
    cartCount.classList.remove('is-adding');
    void cartBtn.offsetWidth;
    cartBtn.classList.add('is-adding');
    cartCount.classList.add('is-adding');
    setTimeout(function () {
      cartBtn.classList.remove('is-adding');
      cartCount.classList.remove('is-adding');
    }, 600);
  }

  // initial count from the live cart
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { setCount(cart.item_count); })
    .catch(function () {});

  document.querySelectorAll('form.tw-atc-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.tw-atc');
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCount(cart.item_count);
          bounce();
        })
        .catch(function () { form.submit(); }) // graceful fallback to native
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });
})();
